import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { format } from 'date-fns';
import { OverlayTrigger, Tooltip, Button } from 'react-bootstrap';
import LockIcon from 'mdi-react/LockIcon';
import LockOpenVariantIcon from 'mdi-react/LockOpenVariantIcon';
import history from 'browserHistory';
import { reservationsSelector } from 'modules/manager/containers/Booking/services/selectors';
import { postCellRequest } from 'modules/manager/containers/Booking/services/actions';
import moment from 'moment';
import BookingHelper from '../../utils';
import ModalWrapper from '../../../ModalWrapper';
import { useModal } from '../../../hooks';
import styles from '../../BookingTable.module.scss';

const HeaderCell: React.FC = (props: any) => {
  const dispatch = useDispatch();
  const { isShow, openModal, closeModal } = useModal();

  const { books } = useSelector(reservationsSelector);
  const [isBlocked, setIsBlocked] = useState<boolean>(true);

  const isDirector = history.location.pathname.split('/')[1] === 'director';
  const currentDate = BookingHelper.formatDate(new Date());
  const dateCell = props.children[1]?.split(' ')[0];
  const splitDate = dateCell !== undefined ? dateCell?.split('.') : '';
  const date = new Date(`${splitDate[2]}.${splitDate[1]}.${splitDate[0]}`);
  const twoWeeks = moment(new Date()).add(14, 'days').unix();
  const isTwoWeeks = moment(date).unix() < twoWeeks;
  const isPast = moment(new Date()).unix() > moment(date).unix();
  const onHide = () => {
    closeModal();
  };

  const onBlockCell = (block: boolean) => {
    setIsBlocked(false);
    const dateToSplit = dateCell?.split('.');
    const dateToCell = new Date(`${dateToSplit[2]}.${dateToSplit[1]}.${dateToSplit[0]}`);
    dispatch(
      postCellRequest(
        `${moment(dateToCell).format('YYYY-MM-DDT00:00:00')}`,
        `${moment(dateToCell).format('YYYY-MM-DDT23:59:59')}`,
        block,
        1,
      ),
    );
    onHide();
  };

  const handleBlockCell = () => openModal();
  useEffect(() => {
    if (books && isDirector && !isPast) {
      const currentBook = books.filter(
        (allBook: any) => format(new Date(allBook.createdDate || ''), 'dd.MM.yyyy') === dateCell,
      );

      // setTodayBooks(currentBook);
      const blockedCell = currentBook.filter((bookBlock) => bookBlock.isBlocked);

      if (blockedCell.length > 10) setIsBlocked(false);
    }
  }, []);

  return (
    <>
      <th {...props} className={currentDate === props.children[1] ? styles.current : ''}>
        {props.children}
        {props.children[1] && isDirector && !isPast && isTwoWeeks ? (
          <OverlayTrigger
            key={props.children[1]}
            placement="top"
            // eslint-disable-next-line
          overlay={
              <Tooltip id={`tooltip-${props.children[1]}`}>
                {isBlocked ? 'Заблокувати ' : 'Розблокувати '}всю дату
              </Tooltip>
            }
          >
            <button type="button" onClick={handleBlockCell} className={styles.buttonBlockCell}>
              {!isBlocked ? (
                <LockOpenVariantIcon size={16} className="pb-1" />
              ) : (
                <LockIcon size={16} className="pb-1" />
              )}
            </button>
          </OverlayTrigger>
        ) : null}
      </th>

      <ModalWrapper show={isShow} onHide={onHide}>
        <div>
          <h6 className="text-center mb-5">Блокування всього дня {dateCell}</h6>
          <div className="d-flex justify-content-center mt-3">
            <Button className="px-5 mr-5" variant="outline-danger" onClick={() => onBlockCell(true)}>
              Заблокувати
            </Button>
            <Button className="px-5" variant="outline-danger" onClick={() => onBlockCell(false)}>
              Розблокувати
            </Button>
          </div>
        </div>
      </ModalWrapper>
    </>
  );
};

export default HeaderCell;
